import { service } from './service'; // 保存公告

export function SaveData(data) {
  return service({
    url: 'Notice/SaveData',
    data: data,
    method: 'post'
  });
} // 获取编号

export function GetOneById(params) {
  return service({
    url: 'Notice/GetOneById',
    params: params,
    method: 'get'
  });
} // 获取公告

export function LoadData(params) {
  return service({
    url: 'Notice/LoadData',
    params: params,
    method: 'get'
  });
} // 删除公告

export function DeleteData(data) {
  return service({
    url: 'Notice/DeleteData',
    data: data,
    method: 'post'
  });
} // 公告附近上传

export function UploadFile(data) {
  return service({
    url: 'Notice/UploadFile',
    data: data,
    method: 'post'
  });
} // 查询最新前N条公告数据（免权限）

export function LoadTopData(params) {
  return service({
    url: 'Notice/LoadTopData',
    params: params,
    method: 'get'
  });
}